import type { FC, ReactNode } from "react";

import * as styles from "./PatientRxBackground.styles";

interface Props {
  children: ReactNode;
}

const PatientRxBackground: FC<Props> = ({ children }) => {
  return <div css={styles.background}>{children}</div>;
};

export { PatientRxBackground };
